import { TCoords } from '@/hooks/useLocation';
import { EHospitalStatus } from '@/types';

/**
 * @description global network hospital tracking stats
 */
export interface INHTrackingStats {
  /**
   * whether the user has opened independently or through create-a-claim flow
   */
  context: 'standalone' | 'create-a-claim';
  providerName: string;
  tpaName: string;
  isWebView: boolean;
  searchString: string;
  /**
   * on - user has location on
   * off - user has location off
   * disabled - user has location disabled
   */
  locationState: 'on' | 'off' | 'disabled';
}

/**
 * @description hospital specific tracking stats
 */
export interface INHTrackingHospitalStats {
  /**
   * index of the hospital in the list
   */
  resultPosition: number | null | undefined;
  resultTab: EHospitalStatus;
  /**
   * total number of results in tab
   */
  resultTabCount: number;
  hospitalId: string | null;
  hospitalCity: string | null;
  hospitalPin: string | null;
}

const getNHTrackingStats = ({
  isInCreateFlow,
  insurerName,
  tpaName,
  isWebView,
  query,
  isLocationRejected,
  location,
  hospitalCity,
  hospitalId,
  hospitalIndex,
  hospitalPin,
  totalResults,
  selectedTab,
}: {
  isInCreateFlow: boolean;
  insurerName: string;
  tpaName: string;
  isWebView: boolean;
  query: string;
  location: TCoords;
  isLocationRejected: boolean;
  totalResults: number;
  selectedTab: EHospitalStatus;
  hospitalIndex?: number | null;
  hospitalId?: string | null;
  hospitalCity?: string | null;
  hospitalPin?: string | null;
}): { global: INHTrackingStats; hospital?: INHTrackingHospitalStats } => {
  return {
    global: {
      context: isInCreateFlow ? 'create-a-claim' : 'standalone',
      providerName: insurerName,
      tpaName,
      isWebView,
      searchString: query,
      locationState: isLocationRejected ? 'disabled' : location ? 'on' : 'off',
    },
    hospital: {
      resultPosition: hospitalIndex ?? null,
      resultTab: selectedTab,
      resultTabCount: totalResults,
      hospitalId: hospitalId ?? null,
      hospitalCity: hospitalCity ?? null,
      hospitalPin: hospitalPin ?? null,
    },
  };
};

export default getNHTrackingStats;
